import AbstractNetworkStatus from '../all/AbstractNetworkStatus';

class NetrangeNetworkStatus extends AbstractNetworkStatus {
  constructor() {
    super();
  }

  isOnline() {
    console.log('[NetworkStatus] checking Netrange...');
    return this.onlineByAjax();
  }
}

export default NetrangeNetworkStatus;



// WEBPACK FOOTER //
// ./src/devices/netrange/NetworkStatus.js